import React from 'react';
import PropTypes from 'prop-types';

import HitThumbnail from './HitThumbnail/HitThumbnail.js';
import HitAddedTag from './HitAddedTag/HitAddedTag.js';

function HitThumbnails({
    addedTime,
    gallery,
    galleryUrl,
    miniHit,
    spu,
    thumbnailUrl1,
    thumbnailUrl2,
    thumbnailUrl3
}) {
    let addedTag = null;

    if (miniHit) {
        return (
            <div
                className="card__imgs scratchpad-thumbnails"
            >
                <HitThumbnail
                    galleryUrl={galleryUrl}
                    spu={spu}
                    url={thumbnailUrl1}
                />
            </div>
        );
    }

    if (gallery && addedTime) {
        addedTag = (<HitAddedTag
            addedTime={addedTime}
                    />);
    }

    return (
        <div
            className="card__imgs scratchpad-thumbnails"
        >
            <HitThumbnail
                galleryUrl={galleryUrl}
                spu={spu}
                url={thumbnailUrl1}
            />
            <HitThumbnail
                galleryUrl={galleryUrl}
                spu={spu}
                url={thumbnailUrl2}
                className="hidden-xs hidden-gallery hidden-mini"
            />
            <HitThumbnail
                galleryUrl={galleryUrl}
                spu={spu}
                url={thumbnailUrl3}
                className="hidden-xs hidden-gallery hidden-mini"
            />
            {addedTag}
        </div>
    );
}

HitThumbnails.propTypes = {
    addedTime: PropTypes.string,
    gallery: PropTypes.bool,
    galleryUrl: PropTypes.string.isRequired,
    miniHit: PropTypes.bool.isRequired,
    spu: PropTypes.string.isRequired,
    thumbnailUrl1: PropTypes.string,
    thumbnailUrl2: PropTypes.string,
    thumbnailUrl3: PropTypes.string
};

export default HitThumbnails;



// WEBPACK FOOTER //
// ./src/universal/components/Hit/HitSubComponents/HitThumbnails/HitThumbnails.js